html {
  margin: 0;
  padding: 0;
}
body {
  margin: 0;
  padding: 0;
}
#map {
  position: absolute;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.leaflet-popup-pane {
  opacity: 0.88;
}
.leaflet-popup-content-wrapper {
  border-radius: 3px;
}
